import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../Common/Modal/CustomModal";
import { useDispatch } from "react-redux";
import {
  createAdditionalPointReport,
  createEducatorReport,
  createManagerReport,
  createReceiptReport,
} from "../../../actions/user";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useSelector } from "react-redux";
import { fetchCountryFormList } from "../../../actions/country";
import InputField from "./InputField";
import { Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { basicFormValidationHandler } from "../../../utils";

const StatisticModal = (props) => {
  const { show, hideModal } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { countryFormList } = useSelector((state) => state.countryReducer);
  const [data, setData] = useState({
    dateFrom: "",
    dateTo: "",
    countryId: "",
  });
  const [typeReport, setTypeReport] = useState("receiptReport");
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  const clientValidationHandler = () => {
    const { dateFrom, dateTo, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      dateFrom,
      dateTo,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmitAction = () => {
    if (clientValidationHandler()) {
      return;
    }

    // POZIV AKCIJE NA OSNOVU TYPE-a
    switch (typeReport) {
      case "receiptReport":
        dispatch(createReceiptReport(data));
        break;

      case "managerReport":
        dispatch(createManagerReport(data));
        break;

      case "educatorReport":
        dispatch(createEducatorReport(data));
        break;

      case "additionalPointReport":
        dispatch(createAdditionalPointReport(data));
        break;

      default:
        toast.error("Unknown report type");
        return;
    }
  };

  return (
    <CustomModal
      show={show}
      hideModal={hideModal}
      modalTitle={t("button.statistic")}
      size="md"
      actionSubmitModal={handleSubmitAction}
    >
      <Col lg={12} className="mb-4">
        <FormControl
          fullWidth
          size="small"
          required
          error={Boolean(errors.countryId)}
        >
          <InputLabel id="demo-simple-select-label">
            {t("storeForm.country")}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={data?.countryId}
            name="countryId"
            label={t("storeForm.country")}
            onChange={handleInputChange}
            size="small"
          >
            {countryFormList?.map((item, key) => (
              <MenuItem value={item.id} key={key}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          {errors.countryId && (
            <FormHelperText>{errors.countryId}</FormHelperText>
          )}
        </FormControl>
      </Col>
      <Col lg={12} className="mb-4">
        <InputField
          type="date"
          label={t("promotionAddForm.dateFrom")}
          name="dateFrom"
          value={data?.dateFrom}
          onChange={handleInputChange}
          error={errors}
          errorsHandler={setErrors}
          fullWidth
          size="small"
          required
          inputLabelProps={{ shrink: true }}
          inputProps={{
            max: data?.dateTo || undefined,
          }}
        />
      </Col>
      <Col lg={12} className="mb-4">
        <InputField
          type="date"
          label={t("promotionAddForm.dateTo")}
          name="dateTo"
          value={data?.dateTo}
          onChange={handleInputChange}
          error={errors}
          errorsHandler={setErrors}
          fullWidth
          size="small"
          required
          inputLabelProps={{ shrink: true }}
          inputProps={{
            min: data?.dateFrom || undefined,
          }}
        />
      </Col>
      <Col lg={12} className="mb-3">
        <FormControl fullWidth size="small" required>
          <InputLabel id="demo-simple-select-label">
            {t("storeForm.typeReport")}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={typeReport}
            name="countryId"
            label={t("storeForm.typeReport")}
            onChange={(e) => setTypeReport(e.target.value)}
            size="small"
          >
            <MenuItem value={"receiptReport"}>Izveštaj o računima</MenuItem>
            <MenuItem value={"managerReport"}>Izveštaj za menadžere</MenuItem>
            <MenuItem value={"educatorReport"}>Izveštaj za edukatore</MenuItem>
            <MenuItem value={"additionalPointReport"}>
              Izveštaj o dodatnim poenima
            </MenuItem>
          </Select>
        </FormControl>
      </Col>
    </CustomModal>
  );
};

export default StatisticModal;
